<div *ngIf="diff$ | async; let diff">
    <mat-icon [matTooltip]="diff">
        sync
    </mat-icon>
</div>
